import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';

const EmployeeCarouselInner = styled.div`
  max-width: 900px;
  margin: 0 auto;
  margin-bottom: 80px;
`;

const ImgP = styled.div`
    width: 412px;
    height: 500px;
    border-radius: 4px;
    box-shadow: 0px 1px 12px 0 rgba(0, 0, 0, 0.2);
    border: solid 0.5px rgba(0, 0, 0, 0.02);
    margin: 0 auto;

    img {
      width: 100%;
      border-radius: 4px;
    }


    @media (min-width: 768px) {
      margin-left: 80px;
    }
`;

const CarouselItemInner = styled.div`
  padding: 10px;

  @media (min-width: 768px) {
    display: flex;
  }
`;

const CarouselItemContent = styled.div`
  height: inherit;
  display: flex;
  align-items: center;

  @media (min-width: 768px) {
    margin-left: -80px;
  }
`;

const CarouselItemContentInner = styled.div`
  background: white;
  box-sizing: border-box;
  width: 495px;
  padding: 56px 82px 42px 92px;
  border-radius: 4px;
  box-shadow: 0px 1px 12px 0 rgba(0, 0, 0, 0.2);
  border: solid 0.5px rgba(0, 0, 0, 0.02);
  margin: 0 auto;

  @media (min-width: 768px) {
    margin: 0;
  }
`;

const Quote = styled.div`
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
`;

const Name = styled.div`
  padding-top: 16px;
  font-size: 22px;
  font-weight: 600;
  line-height: 36px;
`;

const Dept = styled.div`
  color: #999999;
  font-size: 22px;
  font-weight: 400;
`;

function EmployeeCarousel({ input }) {
  const settings = {
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
  };

  return (
    <div>
      <EmployeeCarouselInner>
        <Slider {...settings}>
          {input.items.map((item, i) => {
            return (
              <div key={i}>
                <CarouselItemInner>
                  <ImgP><img src={item.image.url} /></ImgP>
                  <CarouselItemContent>
                    <CarouselItemContentInner>
                      <Quote>{item.quote.text}</Quote>
                      <Name>{item.employee_name.text}</Name>
                      <Dept>{item.department.text}</Dept>
                    </CarouselItemContentInner>
                  </CarouselItemContent>
                </CarouselItemInner>
              </div>
            );
          })}
        </Slider>
      </EmployeeCarouselInner>
    </div>
  );
}

export { EmployeeCarousel };
